import '../App.css';
import { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import { Box, Grid, Button, Container, Dialog, DialogTitle, DialogActions, DialogContent, Snackbar, Alert } from '@mui/material';

import Tier_1 from '../assets/1-Tier_512.jpg';
import Tier_2 from '../assets/2-Tier_512.jpg';
import Tier_3 from '../assets/3-Tier_512.jpg';
import Tier_4 from '../assets/4-Tier_512.jpg';
import metamask from '../assets/metamask.svg';
import walletconnect from '../assets/walletconnect.svg';
import NftMinCard from './nft-mint-card';
import { CloseRounded, WalletOutlined } from '@mui/icons-material';
import { EthereumProvider } from '@walletconnect/ethereum-provider';
import abi from './abi.json'

const projectId = '726c143e12b205ca31c9ffad961ed7aa';
const contractAddress = '0xF7B7AEAfccdC6f1bC9062af8f83DF4a5534F0Ed4'; // testnet
const rpcUrl = 'https://mainnet.infura.io/v3/6596b313510641bc9bb08df172f5280c'; // testnet
const prices = [
    0.1, 0.12, 0.15, 0.17
];

function MarketPlace() {
    const [width, setWindowWidth] = useState(0);
    const [height, setWindowHeight] = useState(0);

    const [isOpenWalletSelector, setIsOpenWalletSelector] = useState(false);
    const [isWalletConnected, setIsWalletConnected] = useState(false);
    const [haveMetamask, setHaveMetamask] = useState(true);
    const [accountAddress, setAccountAddress] = useState('');
    const [accountBalance, setAccountBalance] = useState('');

    const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
    const [message, setMessage] = useState("");

    const [minted, setMinted] = useState([0, 0, 0, 0]);
    const [provider, setProvider] = useState(null);

    const { ethereum } = window;

    const targetTime = new Date("7/16/2023, 08:00:00 PM");

    const [countdown, setCountdown] = useState(calculateCountdown());

    useEffect(() => {
        const interval = setInterval(() => {
            const remainingTime = calculateCountdown();
            setCountdown(remainingTime);

            if (remainingTime <= 0) {
                clearInterval(interval);
            }
        }, 1000);

        updateDimensions();
        window.addEventListener("resize", updateDimensions);

        const { ethereum } = window;
        // const checkMetamaskAvailability = async () => {
        //     if (!ethereum) {
        //         setHaveMetamask(false);
        //     }
        //     setHaveMetamask(true);
        // };

        // checkMetamaskAvailability();

        fetchProperties();
        return () => {
            clearInterval(interval);
            window.removeEventListener("resize", updateDimensions);
        }
    }, []);

    Date.prototype.getUTCTime = function () {
        return this.getTime() - (this.getTimezoneOffset() * 60000);
    };

    function calculateCountdown() {
        const now = new Date();
        const utcTime = now.toLocaleString("en-US", { timeZone: "UTC" });
        const currentTime = new Date(utcTime);

        const timeDifference = targetTime - currentTime;
        return Math.max(0, Math.floor(timeDifference / 1000));
    }

    function formatTime(date) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    function formatDuration(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        const formattedHours = hours.toString().padStart(2, "0");
        const formattedMinutes = minutes.toString().padStart(2, "0");
        const formattedSeconds = remainingSeconds.toString().padStart(2, "0");

        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }

    const updateDimensions = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        setWindowWidth(width);
        setWindowHeight(height);
    }

    const isMobile = () => {
        return width < 1280;
    }

    const openWalletSelector = () => {
        if (isWalletConnected) return;
        setIsOpenWalletSelector(true);
    }

    const connectWallet = async () => {
        setIsOpenWalletSelector(false);
        try {
            const provider = await EthereumProvider.init({
                projectId: projectId, // REQUIRED your projectId
                chains: [1], // REQUIRED chain ids
                showQrModal: true, // REQUIRED set to "true" to use @walletconnect/modal
                methods: ['eth_sendTransaction', 'eth_signTypedData', 'eth_signTypedData_v4', 'eth_sign'], // REQUIRED ethereum methods
                events: ['chainChanged', 'accountsChanged', 'connect', 'session_event', 'display_uri', 'disconnect'], // REQUIRED ethereum events
            });

            // session established
            provider.on('connect', (res) => {
                provider.request({ method: 'eth_requestAccounts' }).then((accounts) => {
                    console.log('connect', accounts);
                    setAccountAddress(accounts[0]);
                    setIsWalletConnected(true);
                });
            });

            await provider.connect();

            const web3Provider = new ethers.providers.Web3Provider(provider);
            setProvider(web3Provider);
        } catch (error) {

        }
    }

    const connectMetamaskExtension = async () => {
        try {
            setIsOpenWalletSelector(false);
            if (!ethereum) {
                setHaveMetamask(false);
                return;
            }

            const accounts = await ethereum.request({
                method: 'eth_requestAccounts',
            });

            const provider = new ethers.providers.Web3Provider(window.ethereum);
            let balance = await provider.getBalance(accounts[0]);
            let bal = ethers.utils.formatEther(balance);

            setAccountAddress(accounts[0]);
            setAccountBalance(bal);
            setIsWalletConnected(true);

            setProvider(provider);
        } catch (error) {
            setIsWalletConnected(false);
        }
    };

    const getAddressText = () => {
        return accountAddress.slice(0, 5) + "..." + accountAddress.slice(accountAddress.length - 4);
    }

    const fetchProperties = () => {
        const provider = new ethers.providers.JsonRpcProvider(rpcUrl);
        const exclusiveNft = new ethers.Contract(contractAddress, abi, provider);
        exclusiveNft.getMintedNFTs().then((res) => {
            setMinted(res);
        });
    }

    const handleClick = async (value) => {
        try {
            if (isWalletConnected === false) {
                setMessage("ERROR: Please connect your wallet!");
                setIsOpenSnackbar(true);
                return;
            }

            const signer = provider.getSigner(accountAddress);
            const exclusiveNft = new ethers.Contract(contractAddress, abi, signer);

            const totalPrice = (prices[value.tier - 1] * value.quantity).toFixed(3).toString();
            console.log(totalPrice);
            const valueToSend = ethers.utils.parseEther(totalPrice);
            const transaction = await exclusiveNft.mint(accountAddress, value.quantity, value.tier - 1, {
                value: valueToSend
            });
            const transactionReceipt = await transaction.wait();
            if (transactionReceipt.status !== 1) {
                setMessage("ERROR: Transaction Error!");
                setIsOpenSnackbar(true);
                return;
            }
            setMessage("Success: Check your NFT in OpenSea");
            setIsOpenSnackbar(true);
        } catch (error) {
            setMessage("ERROR: Please check your balance!");
            setIsOpenSnackbar(true);
        }
    }

    return (
        <div className='market-place'>
            <Snackbar open={isOpenSnackbar} autoHideDuration={6000} onClose={() => { setIsOpenSnackbar(false) }}>
                <Alert severity="success" sx={{ width: '100%' }} onClose={() => { setIsOpenSnackbar(false) }}>
                    {message}
                </Alert>
            </Snackbar>
            <Dialog onClose={() => { }} open={isOpenWalletSelector}>
                <DialogTitle>Connect your wallet</DialogTitle>
                <DialogContent sx={{minWidth: "250px"}}>
                    {!isMobile() && <Button autoFocus className='wallet-connect-button' onClick={() => connectMetamaskExtension()} startIcon={<img src={metamask} className='wallet-icon'></img>}>
                        MetaMask
                    </Button>}
                    <Button autoFocus className='wallet-connect-button' onClick={() => connectWallet()} startIcon={<img src={walletconnect} className='wallet-icon'></img>}>
                        WalletConnect
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => setIsOpenWalletSelector(false)} sx={{ position: "absolute", top: "8px", right: "8px" }}>
                        <CloseRounded></CloseRounded>
                    </Button>
                </DialogActions>
            </Dialog>
            {
                countdown > 0 ? <div className='title-logo-mobile' style={{ fontSize: "72px", color: "#ccc", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>{formatDuration(countdown)}</div> :
                    <div>
                        <div className='market-place-header'>
                            <Button variant='outlined' sx={{ fontWeight: "bold", boxShadow: "0px 0px 0px 4px rgba(255,255,255,0.2)", marginRight: "12px" }} onClick={() => { window.open("https://etherscan.io/address/0xF7B7AEAfccdC6f1bC9062af8f83DF4a5534F0Ed4", "_blank", "noreferrer") }}>CONTRACT</Button>
                            <Button variant='outlined' sx={{ fontWeight: "bold", boxShadow: "0px 0px 0px 4px rgba(255,255,255,0.2)" }} startIcon={<WalletOutlined></WalletOutlined>} onClick={() => openWalletSelector()}>{isWalletConnected ? getAddressText() : "CONNECT"}</Button>
                        </div>
                        <Container className='market-place-content'>
                            <div className={isMobile() ? 'title-logo-mobile' : 'title-logo'}>RAONWARS</div>
                            <p className={isMobile() ? 'maketplace-text-mobile' : 'maketplace-text'}>Discover the power of creation with RAONWARS NFT Minting, where you can bring your imagination to life and craft unique digital treasures that hold immense value and open doors to exclusive in-game rewards, rare items, and unforgettable experiences in the realm of gaming.<br />Don't miss your chance to join the elite group of NFT owners and showcase your creativity to the world!</p>
                            <Box>
                                <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
                                    <Grid item xs={12} sm={6} md={6} lg={3} sx={{ marginBottom: "50px" }}>
                                        <NftMinCard image={Tier_1} handleClick={(value) => { handleClick(value) }} title="EXCLUSIVE NFT" prices={prices} tier="1" minted={minted[0]} supply="1000" isWalletConnected={isWalletConnected}></NftMinCard>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={3} sx={{ marginBottom: "50px" }}>
                                        <NftMinCard image={Tier_2} handleClick={(value) => { handleClick(value) }} title="EXCLUSIVE NFT" prices={prices} tier="2" minted={minted[1]} supply="500" isWalletConnected={isWalletConnected}></NftMinCard>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={3} sx={{ marginBottom: "50px" }}>
                                        <NftMinCard image={Tier_3} handleClick={(value) => { handleClick(value) }} title="EXCLUSIVE NFT" prices={prices} tier="3" minted={minted[2]} supply="300" isWalletConnected={isWalletConnected}></NftMinCard>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={3} sx={{ marginBottom: "50px" }}>
                                        <NftMinCard image={Tier_4} handleClick={(value) => { handleClick(value) }} title="EXCLUSIVE NFT" prices={prices} tier="4" minted={minted[3]} supply="200" isWalletConnected={isWalletConnected}></NftMinCard>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Container>
                    </div>
            }

        </div>
    );
}

export default MarketPlace;
